import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { BeatLoader } from 'react-spinners';


function ApexLineAreaChart({ labels, values, selectedCat, xAxisLabel, yAxisLabel, isTimeChart, seriesName, loading }) {

    const itemsPerPage = 10;
    const [currentPage, setCurrentPage] = useState(0);
    const [paginatedValues, setPaginatedValues] = useState([]);
    const [paginatedLabels, setPaginatedLabels] = useState([]);

    const [showArrows, setShowArrows] = useState(false);
    const [showLeftArrow, setShowLeftArrow] = useState(false);
    const [showRightArrow, setShowRightArrow] = useState(false);

    

    useEffect(() => {

        console.debug("values", values)

        const startIndex = currentPage * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;

        let newDataArr = [...values].slice(startIndex, endIndex);
        let newLabelsArr = [...labels].slice(startIndex, endIndex);

        setPaginatedValues(newDataArr);

        setPaginatedLabels(newLabelsArr);


        let totalPages = 0;
        if (values.length) {
            totalPages = Math.ceil(values.length / itemsPerPage);
        }

        console.debug("currentPage totalPages", currentPage, totalPages)

        if (totalPages > 1) {
            setShowArrows(true)
        } else {
            setShowArrows(false)
        }
        let leftArrowVal = false;
        let rightArrowVal = false;
        if (currentPage < totalPages-1 && currentPage !== 0 ) {
            leftArrowVal = true;
            rightArrowVal = true;
        }

        if (currentPage == 0) {
            leftArrowVal = false;
            rightArrowVal = true;
        }

        if (currentPage === totalPages-1) {
            leftArrowVal = true;
            rightArrowVal = false;
        }
        console.debug("leftArrowVal, rightArrowVal", leftArrowVal, rightArrowVal)
        setShowLeftArrow(leftArrowVal);
        setShowRightArrow(rightArrowVal);

    }, [currentPage, values])

    const handlePrevPage = () => {
        if (currentPage > 0) {
            setCurrentPage((prevPage) => prevPage - 1);
        }
    };

    const handleNextPage = () => {
        const startIndex = (currentPage + 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        console.debug("startIndex, endIndex", startIndex, endIndex)
        if (endIndex < values.length) {
            setCurrentPage((prevPage) => prevPage + 1);
        } else if (startIndex < values.length) {
            setCurrentPage((prevPage) => prevPage + 1);
        }
    };

    var options = {
        chart: {
            id: 'apexchart-example',
            type: 'line',
            toolbar: {
                show: true,
                tools: {
                    download: false,
                    selection: false,
                    zoom: false,
                    zoomin: false,
                    zoomout: false,
                    pan: false,
                    reset: false,
                    // customIcons: [
                    //     {
                    //         icon: '<i class="fa-solid fa-arrow-left"></i>',
                    //         class: 'left-arrow-icon',
                    //         title: 'Go to Previous Page',
                    //         index: 0,
                    //         click: () => {
                    //             handlePrevPage()
                    //         }
                    //     },
                    //     {
                    //         icon: '<i class="fa-solid fa-arrow-right"></i>',
                    //         class: 'right-arrow-icon',
                    //         title: 'Go to Next Page',
                    //         index: 0,
                    //         click: () => {
                    //             handleNextPage()
                    //         }
                    //     },
                    // ]
                },
            }
        },
        zoom: {
            enabled: true,
            type: 'x',
            autoScaleYaxis: true,
        },
        grid: {
            show: true,
            padding: {
                // left: 30,
                // right: 30
            }
            // borderColor: '#999',
            // strokeDashArray: undefined,
            // position: 'back',
            // xaxis: {
            //     lines: {
            //         show: true
            //     }
            // },   
            // yaxis: {
            //     lines: {
            //         show: true
            //     }
            // },  
        },
        stroke: {
            curve: 'straight',
            width: 3,
            colors: [selectedCat?.backgroundColor,]
        },
        xaxis: {
            categories: paginatedLabels,
            offsetX: 0,
            title: {
                text: xAxisLabel
            },
            // min: 0,
            // max: 100,
            labels: {
                rotate: 0,
                offsetX: 0,
            }
            // tickAmount: 3,
            // axisBorder: {
            //     show: true,
            //     color: '#999',
            //     height: 1,
            //     width: '100%',
            //     offsetX: 0,
            //     offsetY: 0
            // }
        },
        fill: {
            type: 'solid',
            colors: [selectedCat?.backgroundColor],
            opacity: [0.35,],
        },
        // labels: paginatedLabels,
        markers: {
            size: 5,
            colors: [selectedCat?.backgroundColor],
        },
        yaxis: {
            min: !isTimeChart ? 0 : undefined,
            max: !isTimeChart ? 100 : undefined,
            title: {
                text: yAxisLabel
            },
            axisBorder: {
                show: false,
                color: '#999',
                width: 1,
                height: '100%',
                offsetX: 0,
                offsetY: 0
            }
        },
        tooltip: {
            // enabled: true,
            shared: true,
            intersect: false,
            marker: {
                fillColors: [selectedCat?.backgroundColor]
            },
            y: {
                show: true,
                // format: 'dd MMM',
                formatter: (value) => {
                    if (value === 0) {
                        return `<div>0</div>`
                    }
                    return `${value}`
                },
            }
        }

    }

    // var series = [{
    //     name: seriesName,
    //     type: 'area',
    //     data: paginatedValues
    // }]
    return (
        <div className='line-area-chart'>
            <Chart
                options={{
                    ...options,
                    chart: {
                        ...options.chart,
                        toolbar: {
                            ...options.chart.toolbar,
                            show: showArrows,
                            tools: {
                                ...options.chart.toolbar.tools,
                                customIcons: [
                                    {
                                        icon: '<i class="fa-solid fa-arrow-left"></i>',
                                        class: showLeftArrow ? '' : 'left-arrow-icon',
                                        title: 'Go to Previous Page',
                                        index: 0,
                                        click: () => {
                                            handlePrevPage()
                                        }
                                    },
                                    {
                                        icon: '<i class="fa-solid fa-arrow-right"></i>',
                                        class: showRightArrow ? '' : 'right-arrow-icon',
                                        title: 'Go to Next Page',
                                        index: 0,
                                        click: () => {
                                            handleNextPage()
                                        }
                                    },
                                ]
                            }
                        }
                    },
                    xaxis: {
                        ...options.xaxis,
                        categories: paginatedLabels,
                    }
                    // labels: [...paginatedLabels],
                }}
                series={[{
                    name: seriesName,
                    type: 'area',
                    data: paginatedValues
                }]}
                height={'100%'} />

            {/* <div className='chart-arrow-right'>
                Arrow Right
            </div> */}
            {loading ? 
                <div className='chart-loader'>
                        <div className='loader-bg'></div>
                    <BeatLoader color={'#bb0000'} size={12} />
                </div> : null}

        </div>
    )
}

export default ApexLineAreaChart